/* eslint-disable i18next/no-literal-string */
import { Alert, Box, CircularProgress, Typography } from '@mui/material';

function AutoLoginUI({
  demoEmail,
  error,
}: {
  demoEmail: string;
  error: string;
}) {
  return (
    <Box sx={{ textAlign: 'center', padding: 2 }}>
      <CircularProgress size={48} sx={{ marginBottom: 3 }} />
      <Typography variant="h6" gutterBottom>
        Logging you in as {demoEmail}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Please wait while we authenticate you...
      </Typography>
      {error && (
        <Alert severity="error" sx={{ marginTop: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
}

export default AutoLoginUI;
